import { useMemo } from 'react';
import classNames from 'classnames';
import { FooterConferenciasBottom } from './components';

type FooterProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer';

export const FooterConferencias = ({ className }: FooterProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	return (
		<footer className={wrapperClassName}>
			<FooterConferenciasBottom />
		</footer>
	);
};
